// Hero.jsx
import React, { useState, useEffect } from "react";
import "./Hero.css";
import weddding from '../assets/wedding.png'
import birthday from '../assets/birthday.png'
import flowrel from '../assets/floral.png'
import lux from '../assets/luxury.png'
const Hero = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    {
      id: 0,
      image: weddding,
      title: "शानदार Wedding Decor",
      subtitle: "Apne Sapno Ki Shaadi Sajayein",
      description: "Apni shaadi ko ek magical experience banayein hamari best decoration services ke saath. Phoolon ki sajavat se lekar lighting tak, hum har pal ko picture-perfect banate hain.",
      badge: "💍 Wedding Special",
      icon: "fa-ring",
      stats: {
        label: "Weddings Decorated",
        number: "350+"
      }
    },
    {
      id: 1,
      image: lux,
      title: "Luxury Event Styling",
      subtitle: "Har Mauke Ko Khaas Banayein",
      description: "Chahe corporate gala ho ya private party, hamari expert team stunning environment create karti hai jo har guest par lasting impression chhodti hai.",
      badge: "🎯 Premium Events",
      icon: "fa-star",
      stats: {
        label: "Events Styled",
        number: "500+"
      }
    },
    {
      id: 2,
      image: flowrel,
      title: "Elegant Floral Designs",
      subtitle: "Phoolon Ki Nayi Pehchaan",
      description: "Shandar centerpieces se lekar stunning bouquets tak, hamare floral arrangements har celebration mein natural elegance aur vibrant colors add karte hain.",
      badge: "🌺 Floral Artistry",
      icon: "fa-leaf",
      stats: {
        label: "Flower Arrangements",
        number: "1000+"
      }
    },
    {
      id: 3,
      image: birthday,
      title: "Birthday Magic",
      subtitle: "Celebrate Life's Special Moments",
      description: "Har birthday ko unforgettable banayein hamare themed decorations ke saath. Bacchon ki party se lekar milestone celebrations tak, hum khushi aur wonder create karte hain.",
      badge: "🎂 Birthday Special",
      icon: "fa-birthday-cake",
      stats: {
        label: "Birthdays Celebrated",
        number: "250+"
      }
    }
  ];

  // Auto-slide effect
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 6000);
    return () => clearInterval(interval);
  }, [slides.length]);

  // Get current slide data
  const slide = slides[currentSlide];

  // Phone number
  const phoneNumber = "7023332099";

  return (
    <section className="hero" id="home" aria-label="Hero banner">
      {/* Background Slider - Only background images */}
      <div className="hero-slider" aria-hidden="true">
        {slides.map((s, index) => (
          <div
            key={s.id}
            className={`slide ${index === currentSlide ? 'active' : ''}`}
            style={{ backgroundImage: `url(${s.image})` }}
            role="img"
            aria-label={s.title}
          />
        ))}
        <div className="slide-overlay" aria-hidden="true" />
      </div>

      {/* Content - Only render the active slide */}
      <div className="hero-container">
        <div className="hero-content-wrapper">
          <div className="hero-text active">
            <div className="hero-text-inner">
              <div className="hero-badge">
                <i className={`fas ${slide.icon}`} aria-hidden="true" />
                {slide.badge}
              </div>

              <h1 className="hero-title">
                {slide.title} <br />
                <span>{slide.subtitle}</span>
              </h1>

              <p className="hero-description">{slide.description}</p>

              <div className="hero-stats">
                <div className="stat-item">
                  <span className="stat-number">{slide.stats.number}</span>
                  <span className="stat-label">{slide.stats.label}</span>
                </div>
                <div className="stat-divider" role="separator" aria-hidden="true" />
                <div className="stat-item">
                  <span className="stat-number">24/7</span>
                  <span className="stat-label">Support Available</span>
                </div>
                <div className="stat-divider" role="separator" aria-hidden="true" />
                <div className="stat-item">
                  <span className="stat-number">4.9★</span>
                  <span className="stat-label">Client Rating</span>
                </div>
              </div>

              <div className="hero-buttons">
                <a href={`tel:${phoneNumber}`} className="btn-primary">
                  <i className="fas fa-phone-alt" aria-hidden="true" />
                  Call Now
                </a>
                <a href="#services" className="btn-secondary">
                  <i className="fas fa-play-circle" aria-hidden="true" />
                  Explore Services
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;